var site = site || {};
site.extras = site.extras || {};
site.extras.initDone = false;
/*
 Extras
 */
site.extras.upload = {
	init: function (urls, lang) {
		if (site.extras.initDone === false) {
			site.extras.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG,*.pdf;*.PDF;*.doc;*.docx;*.xls;*.xlsx;*.mp4;*.svg;*.gpx;*.xml;*.lottie;*',
				'buttonText': lang.galleryFileBrowse,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};

site.extras = $.extend(site.extras, {
	formHasChanged: false,
	itemForm: function () {
		$('select.urlSitemap').on('change', function () {
			var lang = $(this).data('lang'),
				translated = $('input.url.lang_' + lang),
				target = translated.length ? translated : $('input#url');
			target.val($(this).val());
		});
	},
	categoriesSelect: function () {
		$('select#categoryId').on('change', function () {
			if ($(this).val() != 'selectionKey') {
				window.location = '?categoryId=' + $(this).val();
			}
		});

		$(window).on('beforeunload', function () {
			return 'Any unsaved changes will be lost';
		});

		$(document).on("submit", "form", function (event) {
			$(window).off('beforeunload');
		});
	},
	sort: function (url) {
		var $sortList = $('#sortList');

		$sortList.sortable();
		$sortList.on('sortupdate', function () {
			var order = $(this).sortable('toArray').toString();
			$.ajax({
				type: "POST",
				url: url,
				data: {order: order, _skipResize: 1}
			});
		});

		$('a', '.sortOptions').on('click', function (e) {
			e.preventDefault();
			var $sortList = $('#sortList'),
				listItems = $('li', $sortList),
				method = $(this).data('method'),
				direction = $(this).data('direction');

			listItems.sort(function (a, b) {
				a = $(a).data(method);
				b = $(b).data(method);

				if (direction === 'asc') {
					return typeof a === "string" && typeof b === "string" ? collateStrings(a, b) : a < b ? -1 : a > b ? 1 : 0;
				}
				else {
					return typeof a === "string" && typeof b === "string" ? collateStrings(b, a) : b < a ? -1 : b > a ? 1 : 0;
				}
			});
			$sortList.append(listItems);
			$sortList.trigger('sortupdate');
		});
	},

	formAutocomplete: function(url) {
		var $category = $('#categoryId');
		var categoryId = $category.find('option:selected').val();
		if (!categoryId && $category.attr('type') === 'hidden') {
			categoryId = $category.val();
		}

		$('input[type="text"][data-autocomplete]').autocomplete({
			source: function (request, response) {
				var $this = $(this.element);
				var name = $this.attr('name');

				$.ajax({
					url: url,
					data: { categoryId: categoryId, field: name, term: request.term },
					success: function (data) {
						response(data);
					},
					error: function () {
						response([]);
					}
				});
			}
		});
	}
});

/* sortBy functions & helpers extracted and slightly modified from
 * Sugar Library v1.3.7
 * Freely distributable and licensed under the MIT-style license.
 * Copyright (c) 2012 Andrew Plummer
 * http://sugarjs.com/arrays#sorting
 * https://github.com/Mottie/tablesorter/issues/212
 */
var array = {
		AlphanumericSortIgnoreCase: true,
		AlphanumericSortEquivalents: {}
	},

	// Alphanumeric collation helpers
	collateStrings = function (a, b) {
		var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0,
			tiebreaker = 0;
		a = getCollationReadyString(a);
		b = getCollationReadyString(b);
		do {
			aChar = getCollationCharacter(a, index);
			bChar = getCollationCharacter(b, index);
			aValue = getCollationValue(aChar);
			bValue = getCollationValue(bChar);
			if (aValue === -1 || bValue === -1) {
				aValue = a.charCodeAt(index) || null;
				bValue = b.charCodeAt(index) || null;
			}
			aEquiv = aChar !== a.charAt(index);
			bEquiv = bChar !== b.charAt(index);
			if (aEquiv !== bEquiv && tiebreaker === 0) {
				tiebreaker = aEquiv - bEquiv;
			}
			index += 1;
		} while (aValue != null && bValue != null && aValue === bValue);
		if (aValue === bValue) return tiebreaker;
		return aValue < bValue ? -1 : 1;
	},

	getCollationReadyString = function (str) {
		if (array.AlphanumericSortIgnoreCase) {
			str = str.toLowerCase();
		}
		return str.replace(array.AlphanumericSortIgnore, '');
	},

	getCollationCharacter = function (str, index) {
		var chr = str.charAt(index),
			eq = array.AlphanumericSortEquivalents || {};
		return eq[chr] || chr;
	},

	getCollationValue = function (chr) {
		var order = array.AlphanumericSortOrder;
		return chr ? order.indexOf(chr) : null;
	},

	order = 'AÁÀÂÃĄBCĆČÇDĎÐEÉÈĚÊËĘFGĞHıIÍÌİÎÏJKLŁMNŃŇÑOÓÒÔPQRŘSŚŠŞTŤUÚÙŮÛÜVWXYÝZŹŻŽÞÆŒØÕÅÄÖ',
	equiv = '',
	equivalents = {};

array.AlphanumericSortOrder = $.map(order.split(''), function (str) {
	return str + str.toLowerCase();
}).join('');

$.each(equiv.split(','), function (i, set) {
	var equivalent = set.charAt(0);
	$.each(set.slice(1).split(''), function (i, chr) {
		equivalents[chr] = equivalent;
		equivalents[chr.toLowerCase()] = equivalent.toLowerCase();
	});
});


var extrasLangs = (function ($) {
	var getFormData = function (form) {
		var formObj = {};
		var inputs = $(form).serializeArray();
		$.each(inputs, function (i, input) {
			formObj[input.name] = input.value;
		});
		return formObj;
	};
	return {
		$: $,
		getFormData: getFormData
	};
})(jQuery);
/** @param {extrasLangs} parent */
extrasLangs.forms = (function (parent) {
	"use strict";
	var $ = parent.$;
	function init() {
		var $langForms = $('#extras').find('form.lang');
		if ($langForms) {
			$langForms.each(function(){
				setupLang(this);
			});
		}
	}
	function setupLang(form) {
		var $form = $(form);
		addLangBar($form);
		addIndicators($form);
		checkCurrentLanguage($form);
	}
	function addIndicators($form){
		$form.find('div.elm.lang.eType_wysiwyg').each(function(){
			$(this).prepend($('<span/>').addClass('indicator'));
		});
	}
	function addLangBar($form) {
		var langs = getLangs($form);
		var hasTabs = $form.hasClass('ui-tabs');
		var $ul = $('<ul/>').addClass('langPicker ui-widget-header ui-corner-all');
		if (hasTabs) {
			$ul.addClass('usingTabs');
		}
		$.each(langs, function(i, lang) {
			var $li = $('<li/>').addClass('ui-corner-all ' + lang)
				.attr('rel', lang)
				.attr('title', lang);
			$li.append($('<span/>').text(lang));
			$li.click(function(){
				switchLang($form, this);
			});
			$ul.append($li);
		});
		$ul.find('li').first().trigger('click');
		$form.before($ul);
	}
	function checkCurrentLanguage($form)
	{
		var currentLanguage = $('html').attr('lang');
		if ($.inArray(currentLanguage, getLangs($form))) {
			$('.' + currentLanguage, '.langPicker').trigger('click');
		}
	}
	function switchLang($form, selectedElement) {
		var $langElms = $form.find('div.elm.lang');
		var $selectedElement = $(selectedElement);
		var lang = $selectedElement.attr('rel');
		$langElms.filter('.lang_' + lang).show();
		$langElms.not('.lang_' + lang).hide();
		$selectedElement.parent().find('li').removeClass('selected');
		$selectedElement.addClass('selected');
	}
	function getLangs($form) {
		return $form.data('langs').split(',');
	}

	return {
		init: init
	};
})(extrasLangs);
document.addEventListener("DOMContentLoaded", function () {
	jQuery(extrasLangs.forms.init);
});

MoyaComponents.register('extras.admin.collectionInfo', (el) => {
	const focusPoint = el.querySelector('[data-moya-component="ext.focusPoint"]:not(.loaded)');
	if (focusPoint) {
		MoyaLoader.all([
			'/static/local/ext-focuspoint/js/focusPoint.js',
			'/static/local/ext-focuspoint/css/focusPoint.css',
		]).then(() => {
			MoyaComponents.run(focusPoint);
		});
	}

	const file = el.querySelector('#file');
	if (file) {
		file.required = true;
	}
});

const moyaFetch = MoyaContainer.get('core.fetch');
MoyaComponents.register('extras.admin.focusPointForm', (el) => {
	const button = el.querySelector('#focusPointSave');
	if (!button) {
		return;
	}
	button.addEventListener('click', (e) => {
		e.preventDefault();
		let data = new FormData(el);
		moyaFetch.fetchJson(el.action, 'POST', data)
		.then((res) => {
			if (res.noop === true) {
				return;
			}
			if (res && res.success) {
				const positionUpdated = document.querySelector('.positionUpdated');
				if (positionUpdated) {
					positionUpdated.classList.remove('positionUpdated');
				}
				const modalContainer = document.querySelector('.moya-modal__container');
				if (modalContainer) {
					modalContainer.dataset.updated = 1;
				}
			}
		});
	});
});

MoyaComponents.register('extras.admin.refreshOnModalClose', (el) => {
	MoyaEventHandler.on('modal.hide', () => {
		const modalContainer = document.querySelector('.moya-modal__container');
		if (modalContainer.dataset.updated) {
			location.reload();
		}
	});
});

MoyaComponents.register('extras.admin.imagecollection', (el) => {
	let page = parseInt(el.dataset.page);
	const imagesWrapper = el.querySelector('.images');
	const dataUrl = el.dataset.url;
	const pageCount = parseInt(el.dataset.pageCount);
	const pageSize = parseInt(el.dataset.pageSize);
	const extId = parseInt(el.dataset.extId);
	const extTable = el.dataset.extTable;
	const moyaFetch = MoyaContainer.get('core.fetch');
	const loadMoreButton = el.querySelector('.loadMore button');
	loadMoreButton.addEventListener('click', (e) => {
		let url = dataUrl + '?page=' + ++page + '&pageSize=' + pageSize;
		if (extId && extTable) {
			url += '&extId=' + extId + '&extTable=' + extTable;
		}
		moyaFetch.fetchHtml(url).then(response => {
			response.querySelectorAll('.image').forEach((image) => {
				MoyaComponents.run(image);
				imagesWrapper.append(image);
			});
		});
		if (page === pageCount) {
			el.querySelector('.loadMore').classList.add('hidden');
		}
	});
});
